<ng-container *ngIf="appointment">
    <div
        [@expandCollapse]="mode"
        style="z-index: 9999"
        [ngClass]="{
            'left-1/2 -translate-x-1/2 rounded-t-2xl':
                mode !== 'fullscreen' && position === 'center',
            'right-0 rounded-tl-2xl':
                mode !== 'fullscreen' && position === 'right',
            'left-0 rounded-tr-2xl':
                mode !== 'fullscreen' && position === 'left',
            'left-0 top-0 right-[600px]': mode === 'fullscreen'
        }"
        class="fixed bg-indigo-50 px-4 pt-1 border border-indigo-500 min-w-[680px] bottom-0 transition-all duration-300"
    >
        <div class="flex justify-between">
            <div
                class="text-base mr-auto font-semibold flex items-center gap-2"
            >
                <span
                    *ngIf="appointment.status === 'in-progress'"
                    class="w-2.5 h-2.5 bg-red-600 rounded-full animate-pulse"
                ></span>
                Session:
                <span class="capitalize">{{ appointment.status }}</span>
            </div>
            <div
                *ngIf="mode !== 'fullscreen'"
                class="text-white flex items-center"
            >
                <button
                    nz-button
                    nzType="text"
                    class="text-indigo-500"
                    (click)="position = 'left'"
                >
                    <span
                        nz-icon
                        nzType="vertical-align-bottom"
                        [nzRotate]="90"
                        nzTheme="outline"
                    ></span>
                </button>
                <button
                    nz-button
                    nzType="text"
                    class="text-indigo-500"
                    (click)="position = 'center'"
                >
                    <span
                        nz-icon
                        nzType="vertical-align-middle"
                        [nzRotate]="90"
                        nzTheme="outline"
                    ></span>
                </button>
                <button
                    nz-button
                    nzType="text"
                    class="text-indigo-500"
                    (click)="position = 'right'"
                >
                    <span
                        nz-icon
                        nzType="vertical-align-top"
                        [nzRotate]="90"
                        nzTheme="outline"
                    ></span>
                </button>
            </div>
            <button
                *ngIf="mode !== 'fullscreen'"
                nz-button
                nzType="text"
                class="text-indigo-500 flex items-center cursor-pointer"
                (click)="mode = mode === 'expanded' ? 'collapsed' : 'expanded'"
            >
                <i nz-icon [nzType]="mode === 'expanded' ? 'down' : 'up'"></i>
                <span>{{ mode === 'expanded' ? 'Collapse' : 'Expand' }}</span>
            </button>
            <button
                nz-button
                nzType="text"
                class="text-indigo-500 flex gap-2 items-center cursor-pointer"
                (click)="
                    mode = mode === 'fullscreen' ? 'expanded' : 'fullscreen'
                "
            >
                <span
                    nz-icon
                    [nzType]="
                        mode === 'fullscreen' ? 'fullscreen-exit' : 'fullscreen'
                    "
                    nzTheme="outline"
                ></span>
                <span>{{
                    mode === 'fullscreen' ? 'Exit Fullscreen' : 'Fullscreen'
                }}</span>
            </button>
            <button
                nz-button
                nzType="text"
                class="text-indigo-500 flex gap-2 items-center cursor-pointer"
                (click)="openChat()"
            >
                <span nz-icon nzType="message" nzTheme="outline"></span>
                <span>Open Chat</span>
            </button>
        </div>

        <div class="p-4">
            <div class="grid grid-cols-2 gap-2">
                <div
                    *ngIf="appointment.status === 'in-progress'"
                    class="flex items-center justify-between p-1.5 bg-blue-50 rounded border border-blue-100"
                >
                    <span class="font-medium text-blue-700">Elapsed Time</span>
                    <span class="font-mono text-blue-600">{{
                        appointment.statusHistory?.[
                            appointment.statusHistory.length - 1
                        ]?.updatedAt | elapsedTime
                    }}</span>
                </div>

                <div
                    class="flex items-center justify-between p-1.5 bg-blue-50 rounded border border-blue-100"
                >
                    <span class="font-medium text-blue-700">Chat Status</span>
                    <div class="flex items-center gap-2">
                        <span
                            class="w-2 h-2 rounded-full"
                            [ngClass]="{
                                'bg-green-500':
                                    chatState?.connectionState === 'connected',
                                'bg-yellow-500':
                                    chatState?.connectionState === 'connecting',
                                'bg-red-500':
                                    chatState?.connectionState ===
                                    'disconnected'
                            }"
                        >
                        </span>
                        <span class="text-blue-600">{{
                            chatState?.statusString
                        }}</span>
                    </div>
                </div>

                <div
                    class="flex items-center justify-between p-1.5 bg-white rounded border border-gray-100"
                >
                    <span class="font-medium text-gray-700">Customer</span>
                    <a
                        [routerLink]="
                            customerFacade.getCustomerUrl(
                                appointment.relatedToLead?.['_id']
                            )
                        "
                        class="text-gray-600 hover:text-indigo-600"
                        >{{ appointment.relatedToLead?.['firstName'] }}
                        {{ appointment.relatedToLead?.['lastName'] }}</a
                    >
                </div>

                <div
                    class="flex items-center justify-between p-1.5 bg-white rounded border border-gray-100"
                >
                    <span class="font-medium text-gray-700">Service</span>
                    <span class="text-gray-600"
                        >{{ appointment.service?.['label'] }}
                        {{ appointment.service?.['description'] ? '-' : ' ' }}
                        {{ appointment.service?.['description'] }}</span
                    >
                </div>

                <div
                    class="col-span-2 flex items-center justify-between p-1.5 bg-white rounded border border-gray-100"
                >
                    <span class="font-medium text-gray-700">VisitReason</span>
                    <span class="text-gray-600">{{
                        appointment.visitReason || 'Not Specified'
                    }}</span>
                </div>
            </div>
        </div>
        <div>
            <ng-container
                *ngIf="
                    appointment.status !== 'new' &&
                    appointment.status !== 'confirmed'
                "
            >
                <nz-divider
                    nzText="Admin Notes"
                    nzOrientation="left"
                    class="my-2"
                ></nz-divider>

                <div class="flex items-start gap-2">
                    <portals-name-avatar
                        *ngIf="user"
                        [fullName]="user.firstName + ' ' + user.lastName"
                    />
                    <textarea
                        nz-input
                        [disabled]="appointment.status !== 'in-progress'"
                        placeholder="Administrative notes and comments"
                        [nzAutosize]="{ minRows: 2, maxRows: 2 }"
                        [(ngModel)]="adminNotes"
                        class="notesInput"
                    ></textarea>
                </div>

                <nz-divider
                    nzText="Clinical Session Notes"
                    nzOrientation="left"
                    class="my-2"
                ></nz-divider>
                <div
                    class="flex items-start gap-2"
                    *ngIf="lead.isPatient; else missingCustomer"
                >
                    <portals-name-avatar
                        *ngIf="user"
                        [fullName]="user.firstName + ' ' + user.lastName"
                    />
                    <textarea
                        nz-input
                        placeholder="Write a note..."
                        [nzAutosize]="
                            mode === 'fullscreen'
                                ? { minRows: 17, maxRows: 17 }
                                : { minRows: 11, maxRows: 11 }
                        "
                        [(ngModel)]="clinicalNotes"
                        [disabled]="appointment.status !== 'in-progress'"
                    ></textarea>
                </div>
            </ng-container>
            <div class="flex items-center justify-end gap-2 p-4">
                <ng-container *ngIf="appointment.status === 'in-progress'">
                    <button
                        nz-button
                        nzType="primary"
                        nz-dropdown
                        nzPlacement="topLeft"
                        nzTrigger="click"
                        [nzDropdownMenu]="menu"
                    >
                        Finalize Session
                        <i nz-icon nzType="more"></i>
                    </button>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu>
                            <li
                                *ngFor="
                                    let status of [
                                        'no-show',
                                        'cancelled',
                                        'closed',
                                        'completed'
                                    ]
                                "
                                nz-menu-item
                                (click)="
                                    finalizeSession(appointment._id, status)
                                "
                            >
                                {{ status | titlecase }}
                            </li>
                        </ul>
                    </nz-dropdown-menu>
                </ng-container>
                <ng-container
                    *ngIf="
                        appointment.status === 'new' ||
                        appointment.status === 'confirmed'
                    "
                >
                    <button
                        nz-button
                        nzType="primary"
                        nz-dropdown
                        nzPlacement="topLeft"
                        nzTrigger="click"
                        (click)="startSession()"
                    >
                        Start Session
                    </button>
                </ng-container>
                <ng-container
                    *ngIf="
                        appointment.status !== 'new' &&
                        appointment.status !== 'confirmed' &&
                        appointment.status !== 'in-progress'
                    "
                >
                    <button
                        nz-button
                        nzType="primary"
                        nz-dropdown
                        nzPlacement="topLeft"
                        nzTrigger="click"
                        (click)="closeSession()"
                    >
                        Close
                    </button>
                </ng-container>
            </div>

            <ng-template #missingCustomer>
                Unable to write a note for an unknown patient.
            </ng-template>
        </div>
    </div>
</ng-container>
